export default __webpack_public_path__ + "static/media/A5_11.a0bd556c.mp3";